import type { PluginDefinition } from 'yam-types'
import redisProvisioner from './handlers/redis'
import { name, version } from './package.json'
import * as schema from './schema.json'
import * as settings from './settings.json'
import type { RedisConfig } from './types.d'

export default {
  name,
  schema,
  settings,
  version,
  handlers: {
    'prepare[?(@.type=="redis")]': redisProvisioner
  }
} as PluginDefinition<RedisConfig>